import React from 'react';

const SvgIconLocked = (props) => (
  <svg width={12} height={16} {...props}>
    <g fill="#e6e6e6">
      <path d="M6 0C3.794 0 2 1.794 2 4v1.333H0V16h12V5.333h-2V4c0-2.206-1.794-4-4-4zM3.333 4A2.67 2.67 0 016 1.333 2.67 2.67 0 018.667 4v1.333H3.333V4zm7.334 2.667v8H1.333v-8h9.334z" />
      <path d="M5.333 11.877v1.456h1.334v-1.456A1.997 1.997 0 008 10c0-1.103-.897-2-2-2s-2 .897-2 2c0 .868.56 1.601 1.333 1.877zM6 9.333a.668.668 0 010 1.334.668.668 0 010-1.334z" />
    </g>
  </svg>
);

export default SvgIconLocked;
